<template>
  <div class="row" v-if="rfidReaderDelay.length">
    <div class="col-12">
      <div
        style="display: flex; flex: 1; justify-content: space-between"
        class="mb-2"
      >
        <div class="form-inline">
          <input
            type="text"
            v-model="search"
            class="form-control"
            placeholder="Pesquisar..."
          />
        </div>
      </div>

      <b-table
        responsive="xl"
        bordered
        hover
        class="bg-white"
        :items="filteredrfidReaderDelay"
        :fields="fields"
      >
        <template #cell(vehicleId)="{ item }">
          <div class="text-center">
            <button
              class="edit btn btn-action btn-primary btn-circle light-bottom-shadow text-white"
              @click="() => loadLastPositions(item.vehicleId, item.vehicle)"
            >
              <i class="fas fa-eye fa-lg" style="color: black" />
            </button>
          </div>
        </template>

        <template #cell(datetime)="{ item }">
          <div>
            {{ toBRDatetime(item.datetime) }}
          </div>
        </template>

        <template #cell(updated_at)="{ item }">
          <div>
            {{ toBRDatetime(item.updated_at) }}
          </div>
        </template>

        <template #cell(HORAS_ATRASO)="{ item }">
          <div :class="{ 'text-danger': item.toAlert }">
            <i v-show="item.toAlert" class="fas fa-exclamation-triangle mr-1" />

            {{ item.HORAS_ATRASO }}
          </div>
        </template>
      </b-table>
    </div>

    <b-modal
      v-model="showLastPositionsModal"
      :title="last30PositionsTitleModal"
      size="xl"
      ok-only
      ok-title="Fechar"
    >
      <Positions :vehicleId="vehicleIdSelected" />
    </b-modal>
  </div>
</template>

<script>
import LoaderButton from "@/components/button/LoaderButton";
import Combobox from "@/components/shared/ComboBox";
import Positions from "@/components/shared/Positions.vue";
import { formatDatetime, formatBoolean } from "@/lib/util";
import { mapState } from "vuex";

export default {
  name: "RFIDReaderDelayList",

  components: {
    LoaderButton,
    Combobox,
    Positions
  },

  data() {
    return {
      fields: [
        {
          key: "vehicleId",
          label: "Últ. Posi.",
        },
        {
          key: "vehicle",
          label: this.$t("vehicle"),
        },
        {
          key: "client",
          label: this.$t("client"),
        },
        {
          key: "id_motorista",
          label: "ID Motorista",
        },
        {
          key: "tag_remote_id",
          label: "Remote ID",
        },
        {
          key: "datetime",
          label: "Último posicionamento",
        },
        {
          key: "updated_at",
          label: "Data/Hora RFID",
        },
        {
          key: "HORAS_ATRASO",
          label: "Horas Atraso",
        },
      ],
      search: "",
      showLastPositionsModal: false,
      last30PositionsTitleModal: "",
      vehicleIdSelected: null,
    };
  },

  computed: {
    ...mapState({
      rfidReaderDelay: (state) => state.rfidreaderdelay.all,
    }),

    rows() {
      return this.rfidReaderDelay.length;
    },

    filteredrfidReaderDelay() {
      if (!this.search) {
        return this.rfidReaderDelay;
      }

      const search = this.search.toLowerCase();

      return this.rfidReaderDelay.filter((item) => {
        return (
          String(item.vehicle).toLowerCase().includes(search) ||
          String(item.client).toLowerCase().includes(search) ||
          String(item.id_motorista).toLowerCase().includes(search) ||
          String(item.vehiclePlate).toLowerCase().includes(search) ||
          String(item.tag_remote_id).toLowerCase().includes(search)
        );
      });
    },
  },

  methods: {
    loadLastPositions(vehicleId, title) {
      this.vehicleIdSelected = vehicleId;

      this.last30PositionsTitleModal = `Últimas 30 posições [${title}]`

      this.showLastPositionsModal = true;
    },

    toBRDatetime(date) {
      return formatDatetime(date);
    },

    toBooleanString(value) {
      return formatBoolean(value);
    },
  },
};
</script>
